import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const ServiceFeeNote = ({ className = "", kind = null }) => {
  const [fees, setFees] = useState(cache);
  useEffect(() => {
    if (!cache) api.get("/payments/service-fees").then(({ data }) => { cache = data; setFees(data); }).catch(() => {});
  }, []);
  if (!fees) return null;
  const platformApplies = (kind === "tournament" || kind === "league") && fees.platform_fee_enabled !== false;
  const pct = (Number(fees.service_charge_pct) || 0) + (platformApplies ? Number(fees.platform_fee_pct) || 0 : 0);
  const flat = (Number(fees.service_fee_flat) || 0) + (platformApplies ? Number(fees.platform_fee_flat) || 0 : 0);
  if (pct <= 0 && flat <= 0) return null;
  const parts = [];
  if (pct > 0) parts.push(`${Math.round(pct * 100) / 100}%`);
  if (flat > 0) parts.push(`$${flat.toFixed(2)}`);
  const hasPlatform = platformApplies && ((Number(fees.platform_fee_pct) || 0) > 0 || (Number(fees.platform_fee_flat) || 0) > 0);
  return (
    <p className={`text-[10px] text-zinc-500 ${className}`} data-testid="service-fee-note">
      Card payments include a {parts.join(" + ")} {hasPlatform ? "service & platform fee" : "service fee"}
    </p>
  );
};

export default ServiceFeeNote;
